export const PRESENTATION_GET_LAYOUTS = 'PRESENTATION_GET_LAYOUTS';
export const PRESENTATION_GET_LAYOUTS_SUCCESS = 'PRESENTATION_GET_LAYOUTS_SUCCESS';
export const PRESENTATION_GET_LAYOUTS_FAILURE = 'PRESENTATION_GET_LAYOUTS_FAILURE';
export const PRESENTATION_EDIT_LAYOUT = 'PRESENTATION_EDIT_LAYOUT';
export const PRESENTATION_EDIT_LAYOUT_SUCCESS = 'PRESENTATION_EDIT_LAYOUT_SUCCESS';
export const PRESENTATION_EDIT_LAYOUT_FAILURE = 'PRESENTATION_EDIT_LAYOUT_FAILURE';
export const PRESENTATION_LAYOUTS_PROPS_CHANGED = 'PRESENTATION_LAYOUTS_PROPS_CHANGED';
export const PRESENTATION_SELECTING_PROP_CHANGED = 'PRESENTATION_SELECTING_PROP_CHANGED';
export const PRESENTATION_SECTION_SELECTED_PROP_CHANGED = 'PRESENTATION_SECTION_SELECTED_PROP_CHANGED';
export const PRESENTATION_EDITING_SECTION_PROP_CHANGED = 'PRESENTATION_EDITING_SECTION_PROP_CHANGED';
export const PRESENTATION_PROPS_CHANGED = 'PRESENTATION_PROPS_CHANGED';
